import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { NavigationStart, Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { SharedModule } from '../../../shared/shared.module';
import { BREAKPOINTS } from '../../constants/breakpoints.constants';
import { InquiriesRoutePath } from '../../enums/route-types.enum';
import { LogoComponent } from '../logo/logo.component';
import { TreeService } from '../tree.service';

@Component({
  selector: 'app-mobile-navbar',
  templateUrl: './mobile-navbar.component.html',
  styleUrl: './mobile-navbar.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, LogoComponent, RouterLink],
})
export class MobileNavbarComponent implements OnInit, OnDestroy {
  private breakpointObserver = inject(BreakpointObserver);
  private router = inject(Router);
  private treeService = inject(TreeService);

  burgerMenuOpen = false;
  claimsRoutePath = `/${InquiriesRoutePath.ROOT}/${InquiriesRoutePath.CLAIMS}`;
  private subscriptions = new Subscription();

  ngOnInit(): void {
    this.subscriptions.add(
      this.treeService.getBurgerMenuOpenedAsObservable().subscribe((opened) => {
        this.burgerMenuOpen = opened;

        if (opened) {
          document.querySelector('body').classList.add('overflow-hidden');
        } else {
          document.querySelector('body').classList.remove('overflow-hidden');
        }
      }),
    );

    this.subscriptions.add(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.closeBurgerMenu();
        }
      }),
    );

    this.subscriptions.add(
      this.breakpointObserver.observe(`(max-width: ${BREAKPOINTS.SM})`).subscribe((result) => {
        if (!result.matches) {
          this.closeBurgerMenu();
        }
      }),
    );
  }

  openBurgerMenu(): void {
    this.treeService.setBurgerMenuOpened(true);
  }

  closeBurgerMenu(): void {
    this.treeService.setBurgerMenuOpened(false);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
